"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDatabaseCellStorageKey = resolveDatabaseCellStorageKey;
exports.resolveDatabaseCellStorageKeyFromHas = resolveDatabaseCellStorageKeyFromHas;
/** Resolve historical CRUD title cells without overwriting declared values. */
function resolveDatabaseCellStorageKey(cells, propertyId, columns) {
    return resolveDatabaseCellStorageKeyFromHas(key => Object.prototype.hasOwnProperty.call(cells, key), propertyId, columns);
}
function resolveDatabaseCellStorageKeyFromHas(has, propertyId, columns) {
    if (has(propertyId))
        return propertyId;
    const titles = columns.filter(column => column.type === 'title');
    if (titles.length === 1 &&
        titles[0].id === propertyId &&
        !columns.some(column => column.id === 'title' && column.type !== 'title') &&
        has('title'))
        return 'title';
    return propertyId;
}
